import { useStaticQuery, graphql } from 'gatsby';
import '../fragments/search-box';

const useSearchBox = () => {
  const { strapi } = useStaticQuery(graphql`
    query VehiclesUseSearchBox {
      strapi {
        ...SearchBoxFiltersConnection
      }
    }
  `);

  return strapi;
};

export default useSearchBox;
